import { graphql } from 'gql.tada';
import { client } from '../client';
import { pdxEvent } from '../../utils/noflake';

export const getCartQuery = graphql(`
  query GetCart($input: GetCartInput!) {
    cart(input: $input) {
      id
      customerId
      items {
        resolution
        reason {
          title
          id
          fields {
            value
            type
          }
          children {
            title
            id
            fields {
              value
              type
            }
          }
          resolutions {
            id
            scope
          }
        }
        quantity
        item {
          variantId
          sku
          id
        }
        id
        exchange {
          variantInfo {
            value
            name
          }
          variantId
          sku
          productId
          price {
            value
            formattedString
            currency
          }
          name
          image
          id
        }
        delivery {
          type
          serviceProviderId
          serviceType
          packagingOption
          locationProviderId
        }
        comment
      }
      refund {
        type
      }
      delivery {
        type
        serviceProviderId
        serviceType
        packagingOption
        locationProviderId
      }
      attributes {
        value
        name
      }
      address {
        provinceCode
        province
        postalCode
        lastName
        firstName
        countryCode
        city
        address2
        address1
      }
    }
  }
`);

export const getCartQueryFn = async (requestId: string) => {
  pdxEvent({
    event_category: 'get_data',
    event_type: 'get_cart',
    event_value: 'cart',
  });

  try {
    const result = await client.request(getCartQuery, {
      input: {
        requestId,
      },
    });

    pdxEvent({
      event_category: 'get_data',
      event_type: 'get_cart_success',
      event_value: 'cart',
    });

    return result;
  } catch (error) {
    pdxEvent({
      event_category: 'error',
      event_type: 'get_cart_error',
      event_value: 'get_data failed to get cart',
    });
    throw error;
  }
};

export type GetCartResult = Awaited<ReturnType<typeof getCartQueryFn>>;
export type Cart = GetCartResult['cart'];
